import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import {
  NotAuthorized,
  NotFound,
} from '@iarcpsu/emanufac-components/src/components/Error';
import { MainFooter } from '@iarcpsu/emanufac-components/src/components/Footers';
import { Loading } from '@iarcpsu/emanufac-components/src/components/Loading';
import { HomeNavbar } from '@iarcpsu/emanufac-components/src/components/Navbars';
import { MainSidebar } from '@iarcpsu/emanufac-components/src/components/Sidebar';

import * as actions from '../redux/actions';
import accessRight from '../utils/functions/accessRight';
import {
  CreateInternalDeposit,
  CreateOrder,
  CreateQuotation,
  DecreaseOrder,
  DetailInternalDeposit,
  DetailOrder,
  DetailQuotation,
  DetailQuotationByProduct,
  EachInternalDepositTransaction,
  EachQuotationTransaction,
  EditInternalDeposit,
  EditOrder,
  EditQuotation,
  InternalDeposits,
  ManufacturingOrderBySales,
  Orders,
  PreviousQuotations,
  QuotationAndInternalDepositTransactions,
  QuotationByProductList,
  QuotationBySales,
  QuotationByStatus,
  QuotationDashboard,
  QuotationEmployeeList,
  QuotationLogs,
  Quotations,
  RejectQuotation,
  ReviseQuotation,
} from '../views/SPM';
// Sales and Purchase Management
export const SPM = () => {
  const module = 'SPM';
  const prefix = '/spm';
  const name = 'ฝ่ายขาย';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);
  const availableModule = useSelector((state) => state.availableModule);
  const information = useSelector((state) => state.information);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };

  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    console.log('Layout: SPM');
    dispatch(actions.meGet());
    dispatch(actions.informationAll());
    dispatch(actions.availableModuleAll());
    return () => {};
  }, []);

  if (!me?.userData) {
    return <Loading />;
  }

  if (accessRight(me, module, 0, availableModule)) {
    return (
      <div className="min-h-screen">
        <Helmet>
          <meta charSet="utf-8" />
          <title>ฝ่ายขาย - {information?.name || 'E-Manufac'}</title>
        </Helmet>
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
          isTaskbarOpen={sidebarOpen}
          setIsTaskbarOpen={setSidebarOpen}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div
          className={`${
            sidebarOpen ? 'lg:ml-64' : ''
          }   min-h-screen  pt-16 px-8 `}
        >
          <div className="py-4">
            <Switch>
              <Redirect exact from={`${prefix}`} to={`${prefix}/quotation`} />
              <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
              <Route exact path={`${prefix}/orders`}>
                <Orders title="จัดการออเดอร์" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/order/create`}>
                <CreateOrder title="เพิ่มออเดอร์" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/order/edit/:id`}>
                <EditOrder title="แก้ไขออเดอร์" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/order/decrease/:id`}>
                <DecreaseOrder title="ตัดสต๊อกสินค้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/order/detail/:id`}>
                <DetailOrder title="รายละเอียดออเดอร์" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/quotation`}>
                <Quotations title="ใบเสนอราคา" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/create`}>
                <CreateQuotation title="สร้างใบเสนอราคา" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/detail/:id`}>
                <DetailQuotation title="รายละเอียดใบเสนอราคา" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation-log/detail/:id`}>
                <DetailQuotation
                  title="รายละเอียดใบเสนอราคา"
                  subtitle={name}
                  log={true}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/reject/:id`}>
                <RejectQuotation title="ปฏิเสธใบเสนอราคา" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/revise/:id`}>
                <ReviseQuotation title="ออกใบเสนอราคาใหม่" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/edit/:id`}>
                <EditQuotation title="แก้ไขใบเสนอราคา" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/by-status`}>
                <QuotationByStatus
                  title="ใบเสนอราคาในแต่ละสถานะ"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/by-sales/:id`}>
                <QuotationBySales
                  title="ใบเสนอราคาตามพนักงาน"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/by-sales/`}>
                <QuotationEmployeeList
                  title="ใบเสนอราคาตามพนักงาน"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/by-product/`}>
                <QuotationByProductList
                  title="ใบเสนอราคาตามสินค้า"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/by-product/detail/:id`}>
                <DetailQuotationByProduct
                  title="รายการใบเสนอราคาตามสินค้า"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation-history`}>
                <QuotationLogs title="ประวัติใบเสนอราคา" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/find-previous/:id`}>
                <PreviousQuotations title="ใบเสนอราคาเดิม" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/transaction/:id`}>
                <EachQuotationTransaction
                  title="ประวัติกิจกรรมในใบเสนอราคา"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/internal-deposit`}>
                <InternalDeposits title="ใบเบิกใช้ภายใน" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/internal-deposit/edit/:id`}>
                <EditInternalDeposit
                  title="แก้ไขใบเบิกใช้ภายใน"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/internal-deposit/detail/:id`}>
                <DetailInternalDeposit
                  title="รายละเอียดใบเบิกใช้ภายใน"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/internal-deposit/create`}>
                <CreateInternalDeposit
                  title="สร้างใบเบิกใช้ภายใน"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/internal-deposit/transaction/:id`}>
                <EachInternalDepositTransaction
                  title="ประวัติกิจกรรมในใบเสนอราคา"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/quotation/dashboard`}>
                <QuotationDashboard title="รายงานใบเสนอราคา" subtitle={name} />
              </Route>{' '}
              <Route exact path={`${prefix}/qt-id-transaction`}>
                <QuotationAndInternalDepositTransactions
                  title="ประวัติกิจกรรมในใบเสนอราคาและเบิกใช้ภายใน"
                  subtitle={name}
                />
              </Route>{' '}
              <Route
                exact
                path={`${prefix}/manufacturing-order/by-sales/detail/:id`}
              >
                <ManufacturingOrderBySales
                  title="รายการใบเสนอราคาตามสินค้า"
                  subtitle={name}
                />
              </Route>{' '}
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <NotAuthorized />
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    </div>
  );
};

export default SPM;
